// useBacktest — React hook that calls the backend backtest API
import { useState, useCallback } from 'react';
import { backtestAPI } from '@/services/api';

export default function useBacktest() {
  const [results, setResults] = useState(null);
  const [progress, setProgress] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [error, setError] = useState(null);

  const run = useCallback(async (config) => {
    setResults(null);
    setError(null);
    setProgress(10);
    setIsRunning(true);

    try {
      setProgress(30);

      const res = await backtestAPI.run({
        strategyId: config.strategyId,
        startDate: config.startDate,
        endDate: config.endDate,
        initialCapital: config.initialCapital,
        timeframe: config.timeframe || '1Day',
        feeMode: config.feeMode || 'fixed',
        makerFee: config.makerFee || 0,
        takerFee: config.takerFee || 0,
      });

      setProgress(100);
      setResults(res.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsRunning(false);
    }
  }, []);

  const cancel = useCallback(() => {
    setIsRunning(false);
    setProgress(0);
  }, []);

  return { run, cancel, results, progress, isRunning, error };
}
